import { CSSProperties } from "react";
import { Button, createStyles, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import styled from "styled-components";
import { QuitButton } from "../../../components/Back/index";

export const CourseContainer = styled.div`
  height: 85vh;
  box-sizing: border-box;
  padding: 20px;
  text-align: center;
  overflow: scroll;
  z-index: 4 !important;
  background: #ffff;
  padding: 15px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ClientContainer = styled.div`
  box-sizing: border-box;
  padding: 20px;
  text-align: center;
`;

export const NewAddress = styled(Button)<{ error?: boolean }>`
  width: 100%;
  height: 55px;
  background: #f7f7f9;
  border: ${({ error }) => (!error ? "1px solid #757a93" : "1px solid red")};
  cursor: pointer;
  color: ${({ error }) => error && "red"};
`;

export const DeleteButton = styled.div`
  background: #f26d6a;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  padding: auto;
  margin-top: 14px;
  position: absolute;
  right: -5vh;
  cursor: pointer;
`;

export const DeleteProduct = styled.div`
  background: #f26d6a;
  position: absolue;
  border-radius: 50%;
  height: 15px;
  width: 15px;
  padding: auto;
  right: -5vh;
  cursor: pointer;
  float: right;
  margin-top: 18px;
  margin-right: -23px;
  z-index: 1;
`;

export const ProductInfo = styled.div`
  width: 100%;
  background: #e1f3fb;
  border: 1px solid #399ebf;
  border-radius: 5px;
  cursor: pointer;
  height: 40px;
  padding-top: 5px;
  .info {
    color: #399ebf;
    font-weight: 500;
  }
  .counter {
    margin-left: 4px;
    display: inline-block;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    background: #399ebf;
    color: #fff;
    font-weight: 500;
  }
`;

export const AccordionContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  position: relative;
`;

export const AddressModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AddButton = styled.button<{ isAddProduct?: boolean }>`
  display: flex;
  height: 30px;
  width: 30px;
  display: inline-block;
  padding: 0px;
  border: 2px solid #399ebf;
  margin: ${({ isAddProduct }) => (!isAddProduct ? "0px auto 10px -42vw" : "")};
  color: #399ebf;
  float: ${({ isAddProduct }) => (isAddProduct ? "left" : "")};
  background: #ffff;
  cursor: pointer;
  &.MuiInputBase-fullWidth {
    display: none;
  }
`;

export const useAccordianStyle = makeStyles<Theme, { activeElement?: number; identifier: number }>({
  accordionBody: {
    textAlign: "center",
    border: ({ activeElement, identifier }) => (activeElement === identifier ? "1.5px solid #E1F3FB" : "none"),
    marginTop: -50,
    marginBottom: 10,
    paddingTop: "50px",
    paddingBottom: "10px",
    borderRadius: "0px 0px 10px 10px",
  },
  accordionBodyContent: {
    width: "100%",
  },
  expandMorIcon: {
    color: ({ activeElement, identifier }) => (activeElement === identifier ? "#ffff" : "#399EBF"),
  },
  summary: {
    background: ({ activeElement, identifier }) => (activeElement === identifier ? "#399EBF" : "#E1F3FB"),
    color: ({ activeElement, identifier }) => (activeElement === identifier ? "#ffff" : "#399EBF"),
    marginBottom: "4%",
    borderRadius: "10px 10px 0px 0px",
  },
  label: {
    fontWeight: "bold",
  },
});

export const useMaintPageStyle = makeStyles<Theme>({
  root: {
    textAlign: "center",
    width: "45vw",
    margin: "20px auto",
    "& .MuiAccordion-root:before": {
      display: "none",
    },
  },
  quitButton: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    left: 50,
    zIndex: 1,
    marginTop: -10,
  },
  subContainer: {
    overflowY: "scroll",
    marginTop: 70,
    width: "80%",
    alignItems: "center",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  message: {
    marginTop: 20,
    marginBottom: 30,
    fontWeight: 500,
    color: "#399ebf",
  },
  radioButton: {
    marginTop: 40,
    textAlign: "center",
  },
  client: {
    color: "#fff",
    background: "#399EBF",
    position: "relative",
    width: 21,
    height: 20,
    paddingTop: 1,
    borderRadius: "50%",
    fontSize: 12,
  },
  activeClient: {
    position: "relative",
    left: 8,
  },
  skeleton: {
    borderRadius: "15px 15px 0px 0px",
    marginTop: -13,
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "93%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    padding: 10,
    alignItems: "center",
  },
});

export const useCustomRadionButton = makeStyles<Theme, { isIcon: boolean; isChecked: boolean }>({
  formInput: {
    "& svg": {
      width: "30px",
      height: "30px",
      color: ({ isChecked }) => (isChecked ? "#399ebf" : "#757a93"),
    },
    "&.MuiFormControlLabel-root > .MuiFormControlLabel-label": {
      marginLeft: ({ isIcon }) => (!isIcon ? 40 : 35),
      marginTop: ({ isIcon }) => (!isIcon ? 5 : -5),
    },
  },
  customRadioButton: {
    border: ({ isChecked }) => (isChecked ? "2px solid #399ebf" : "2px solid #757a93"),
    height: 30,
    width: 30,
    background: ({ isChecked }) => (isChecked ? "#399ebf" : "#757a93"),
  },
  icon: {
    position: "relative",
    marginLeft: -20,
    right: -2,
    bottom: -12,
  },
  label: {
    position: "relative",
    left: 3,
    color: ({ isChecked }) => (isChecked ? "#399ebf" : "#757a93"),
    fontWeight: 500,
  },
  datePicker: {},
});

export const useCourseFormStyle = makeStyles<Theme>({
  radioButtonContainer: {
    display: "flex",
    width: "90%",
    justifyContent: "space-around",
    gap: "10vw",
    margin: "15px auto 40px auto",
  },
  editAddress: {
    top: -50,
    marginBottom: -50,
    marginRight: 20,
    float: "right",
    "&:hover": {
      background: "none",
    },
  },
  disabled: {
    borderColor: "red",
    background: "#f7f7f9",
    caretColor: "transparent",
  },
});

export const useAddProductStyle = makeStyles<Theme>({
  title: {
    color: "#399EBF",
    fontWeight: 700,
    marginBottom: 30,
  },
  deleteProduct: {
    marginTop: 30,
    position: "relative",
  },
});

export const useAddressStyle = makeStyles({
  title: {
    color: "#399EBF",
    fontWeight: 500,
    marginBottom: 30,
  },
  button: {
    background: "#F19949",
    color: "#ffff",
    height: 35,
    "&:hover": {
      background: "#F19949",
      color: "#ffff",
    },
  },
  table: {
    width: "100%",
    paddingLeft: -60,
    position: "relative",
  },
  progressBar: {
    color: "white",
  },
});

export const mondalButtonsStyle: CSSProperties = {
  minHeight: 35,
  fontWeight: 600,
  padding: -1,
};

export const useDividerStyle = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    color: "#399EBF",
    fontWeight: 700,
  },
  line: {
    height: 1.5,
    background: "#399EBF",
    flex: 1,
    marginTop: 12,
    marginLeft: 15,
  },
});

export const useDeliveryStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    row: {
      width: "100%",
    },
    cel: {
      flex: 1,
    },
    nameContent: {
      fontSize: "14px",
      fontWeight: "bold",
      flex: 1,
    },
    rootAddress: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      color: "#757a93",
      textAlign: "justify",
    },
    label: {
      color: "#757a93",
      fontSize: "18px",
      fontWeight: "bold",
    },
    editAddress: {
      top: -50,
      marginBottom: -50,
      marginRight: 20,
      float: "right",
      "&:hover": {
        background: "none",
      },
    },
    disabled: {
      borderColor: "red",
      background: "#f7f7f9",
      caretColor: "transparent",
    },
    delayError: {
      color: "red",
    },
  })
);

export const useRenderStyle = makeStyles(() =>
  createStyles({
    cel: {
      flex: 1,
    },
    nameContent: {
      fontSize: "14px",
      fontWeight: "bold",
      flex: 1,
    },
    rootAddress: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      color: "#757a93",
      textAlign: "justify",
    },
    label: {
      color: "#757a93",
      fontSize: "18px",
      fontWeight: "bold",
    },
    radioButtonContainer: {
      display: "flex",
      width: "90%",
      justifyContent: "space-around",
      gap: "10vw",
      margin: "15px auto 40px auto",
    },
    editAddress: {
      top: -50,
      marginBottom: -50,
      marginRight: 20,
      float: "right",
      "&:hover": {
        background: "none",
      },
    },
  })
);

export const useFooterStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 40,
    gap: 20,
  },
  cancelButton: {
    background: "#CFECF8",
    color: "#399EBE",
    width: 120,
    height: 40,
    fontWeight: 600,
  },
  confirmButton: {
    background: "#399EBE",
    color: "white",
    width: 120,
    height: 40,
    fontWeight: 600,
    "&:hover": {
      background: "#399EBE",
    },
  },
  skeleton: {
    width: 120,
    height: 65,
    marginTop: -15,
  },
}));

export const useConfirmModalStyle = makeStyles(() =>
  createStyles({
    dialog: {
      overflowY: "unset",
    },
    container: {
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      gap: 20,
    },
    progressBar: {
      color: "#fff",
      marginLeft: 2,
    },
    yesButton: {
      height: 50,
      alignSelf: "center",
      width: 190,
      fontWeight: 500,
      "&:hover": {
        background: "#399EBF",
      },
    },
    cancelButton: {
      height: 50,
      alignSelf: "center",
      width: 190,

      background: "#CFECF9",
      border: "1px solid #399EBF",
      color: "#399EBF",
      fontWeight: "bold",
      "&:hover": {
        background: "#CFECF9",
      },
    },
    message: {
      fontSize: 23,
      fontWeight: "bold",
      color: "#399EBE",
      margin: "70px 0px 0px 0px",
    },
    subMessage: {
      color: "#757a93",
    },
    circle: {
      height: 140,
      width: 140,
      background: "#399EBF",
      borderRadius: "50%",
      position: "absolute",
      top: 5,
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    helperIcon: {
      fontSize: 60,
      fontWeight: "bolder",
      fontStyle: "italic",
      color: "#fff",
      position: "relative",
      left: "40%",
      top: "15%",
      transform: "translateY(-50%, -50%)",
    },
  })
);
